import { Schema } from "rsuite";

const { Model, Types } = Schema;

export type LoginFormType = {
  userId?: string;
  password?: string;
  rememberMe?: boolean;
};

export const LoginFormSchema = Model({
  userId: Types.StringType().isRequired(),
  password: Types.StringType().isRequired(),
  rememberMe: Types.BooleanType(),
});

export const LoginDefaultValues: LoginFormType = {
  userId: "",
  password: "",
  rememberMe: false,
};
